<template>
  <div
      class="absolute left-0 top-0 w-full h-full bg-white dark:bg-slate-800 z-[55] rounded-md px-2 pt-2 lg:px-4 lg:pt-4 overflow-hidden custom-scrollbar flex flex-col gap-2 lg:gap-4">
    <div class="flex flex-wrap justify-between gap-4 w-full">
      <div class="flex flex-row gap-2">
        <Tooltip placement="top" arrow>
          <template #button>
            <div class="email-icon" @click="backToWallets">
              <Icon v-if="locale === 'fa'" icon="akar-icons:arrow-right"/>
              <Icon v-else icon="akar-icons:arrow-left"/>
            </div>
          </template>
          <span>{{ $t('message.back') }}</span>
        </Tooltip>
        <div class="flex flex-col gap-2">
          <span
              class="text-lg text-white">{{
              $t('message.transactions') + ' (' + walletStore.selectedUserName + ')'
            }}</span>
          <span class="text-sm text-slate-300">{{ subTitle }}</span>
        </div>
      </div>
      <AllButtons v-model="keyword" :showFilter="false" :showCategoriesButtons="false" :copyButton="false"
                  :buttonForNewItem="true" :titleForNewItem="t('message.add transaction')"
                  @buttonForNewItemClicked="showAddTransactionModal"/>
    </div>
    <!--    <div
            class="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-0 border-b border-slate-100 dark:border-slate-700 -mx-6 pb-4 px-3 xl:pb-6 xl:px-6"
        >
          <div class="flex-1 flex flex-row gap-2">
            <Tooltip placement="top" arrow>
              <template #button>
                <div class="email-icon" @click="backToWallets">
                  <Icon v-if="locale === 'fa'" icon="akar-icons:arrow-right"/>
                  <Icon v-else icon="akar-icons:arrow-left"/>
                </div>
              </template>
              <span>{{ $t('message.back') }}</span>
            </Tooltip>
            <div class="flex flex-col gap-2">
              <span
                  class="text-lg text-white">{{
                  $t('message.transactions') + ' (' + walletStore.selectedUserName + ')'
                }}</span>
              <span class="text-sm text-slate-300">{{ subTitle }}</span>
            </div>
          </div>
          <div class="flex flex-row gap-4">
            <button @click="showAddTransactionModal"
                    class="btn btn-outline-dark py-1 text-xs font-medium rounded-md">
              {{ $t('message.add transaction') }}
            </button>
            <InputGroup
                v-model="keyword"
                :placeholder="$t('message.search.label')"
                type="text"
                prependIcon="heroicons-outline:search"
                merged
            />
          </div>
        </div>-->
    <!--  end header -->
    <!--  start conent -->
    <div class="-mx-2 lg:-mx-4 overflow-y-auto flex-1">
      <DataTable
          :nullSortOrder="-1"
          :value="walletStore.transactions"
          scrollable
          scrollHeight="flex"
          resizableColumns
          removableSort
          stripedRows
          :filters="filters"
          class="text-sm"
          size="small"
          tableStyle=""
          row-hover
          @row-click="showTransactionDetails"
          :rowClass="() => 'hover:!bg-[#2c4967] even:!bg-[#1A2941] odd:!bg-[#121E31] !text-slate-300 cursor-pointer'"
      >
        <Column field="id" header="ID" :sortable="true"
                class="overflow-hidden text-ellipsis whitespace-nowrap !py-0"
                style="width: 5%; height: 30px">
          <template #sorticon="{ sortOrder }">
            <SortIcon :sortOrder="sortOrder"/>
          </template>
        </Column>
        <Column field="title" :header="t('message.title')" :sortable="true"
                class="overflow-hidden text-ellipsis whitespace-nowrap !py-0 max-w-[200px]"
                style="width: 20%; height: 30px">
          <template #sorticon="{ sortOrder }">
            <SortIcon :sortOrder="sortOrder"/>
          </template>
        </Column>
        <Column field="amount" :header="t('message.amount')" dataType="numeric" :sortable="true"
                class="overflow-hidden text-ellipsis whitespace-nowrap !py-0"
                style="width: 5%; height: 30px">
          <template #sorticon="{ sortOrder }">
            <SortIcon :sortOrder="sortOrder"/>
          </template>
          <template #body="slotProps">
            <span dir="ltr" class="block w-full text-white whitespace-nowrap"
                  :class="{ '!text-red-400': slotProps.data.amount < 0, '!text-success-500': slotProps.data.amount > 0 }">
              <template v-if="slotProps.data.amount <= 0">
                {{ slotProps.data.amount ? formatPrice(slotProps.data.amount) : '' }}
              </template>
              <template v-else>
                {{ slotProps.data.amount ? '+' + formatPrice(slotProps.data.amount) : '' }}
              </template>
            </span>
          </template>
        </Column>
        <Column field="note" :header="t('message.note.label')" :sortable="true"
                class="overflow-hidden text-ellipsis whitespace-nowrap !py-0 max-w-[200px]"
                style="width: 20%; height: 30px">
          <template #sorticon="{ sortOrder }">
            <SortIcon :sortOrder="sortOrder"/>
          </template>
        </Column>
        <Column field="attachment" :header="t('message.attachment.label')" :sortable="true"
                class="overflow-hidden text-ellipsis whitespace-nowrap cursor-pointer"
                style="width: 8%; height: 30px">
          <template #sorticon="{ sortOrder }">
            <SortIcon :sortOrder="sortOrder"/>
          </template>
          <template #body="slotProps">
            <img v-if="slotProps.data?.attachment?.link" :src="slotProps.data.attachment.link"
                 :alt="slotProps.data.attachment.name" @click.stop="openLightbox(slotProps.data.attachment.link)"
                 class="size-8 cursor-pointer object-cover rounded-lg border border-slate-500">
          </template>
        </Column>
        <Column field="datetime" :header="t('message.date')" dataType="numeric" :sortable="true"
                class="overflow-hidden text-ellipsis whitespace-nowrap cursor-pointer"
                style="width: 8%; height: 30px">
          <template #sorticon="{ sortOrder }">
            <SortIcon :sortOrder="sortOrder"/>
          </template>
          <template #body="slotProps">
            <span class="block w-full max-w-max">
              {{ slotProps.data.datetime ? gregorianDate(slotProps.data.datetime, 'HH:mm - DD MMM YYYY') : 'ــــ' }}
            </span>
          </template>
        </Column>
        <template #empty>
          <h1 class="py-2 text-center text-lg">There is no transaction</h1>
        </template>
      </DataTable>
      <AddTransaction v-if="isShowAddTransactionModal" @closeModal="closeAddTransactionModal"
                      :selectedAsset="walletStore.selectedAsset" :selectedUserID="walletStore.selectedUserID"
                      :selectedUserName="walletStore.selectedUserName"/>
      <TransactionDetails v-if="isShowDetails" :data="selectedTransaction" @closeModal="closeTransactionDetails"/>
      <VueEasyLightbox
          :visible="visible"
          :imgs="imageLink"
          @hide="visible = false;"/>
    </div>
  </div>
</template>
<script setup>
import Icon from "@/components/Icon/index.vue";
import Tooltip from "@/components/Tooltip/index.vue";
import {computed, onMounted, ref, watch, provide} from "vue";
import {useWalletStore} from "@/stores/wallet.js";
import {gregorianDate} from "@/utils/gregorianDate.js";
import {formatPrice} from "@/utils/priceFormatter.js";
import {useI18n} from "vue-i18n";
import VueEasyLightbox from "vue-easy-lightbox";
import AddTransaction from "@/views/wallet/AddTransaction2.vue";
import TransactionDetails from "@/views/wallet/TransactionDetails.vue";
import Button from "@/components/Button/index.vue";
import InputGroup from "@/components/InputGroup/index.vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import SortIcon from "@/components/datatable/sortIcon.vue";
import {FilterMatchMode} from "@primevue/core/api";
import AllButtons from "@/views/orders/Shared/AllButtons.vue";

const {t, locale} = useI18n({useScope: 'global'})
const walletStore = useWalletStore();
const search = ref('');
const imageLink = ref(null)
const visible = ref(false);
const activeIndex = ref(0);
const isShowAddTransactionModal = ref(false)
const isShowDetails = ref(false);
const selectedTransaction = ref({})

const keyword = ref('');
const filters = ref({
  global: {value: null, matchMode: FilterMatchMode.CONTAINS},
})
watch(keyword, (val) => {
  filters.value.global.value = val
})

function closeAddTransactionModal() {
  isShowAddTransactionModal.value = false
}

function showAddTransactionModal() {
  isShowAddTransactionModal.value = true
}

const subTitle = computed(() => {
  return 'Current Balance: ' + (walletStore.totalAmount > 0 ? '+' : '') + walletStore.totalAmount + ' ' + walletStore.selectedAsset
})
const closeDetailsEmail = () => {
  walletStore.closeDetailsEmail();
  walletStore.selectedAsset = '';
  walletStore.selectedUserID = null
};
const openLightbox = (imageUrl) => {
  imageLink.value = imageUrl;
  visible.value = true;
};

async function backToWallets() {
  walletStore.closeDetailsEmail();
  walletStore.selectedAsset = '';
  walletStore.selectedUserID = null
  await walletStore.action_getWallets()
}

function showTransactionDetails({data}) {
  isShowDetails.value = true
  selectedTransaction.value = data
}

function closeTransactionDetails() {
  isShowDetails.value = false
  selectedTransaction.value = {}
}

onMounted(() => {
  if (walletStore.selectedUserID != null) {
    walletStore.action_getTransactions({
      userID: walletStore.selectedUserID,
      asset: walletStore.selectedAsset
    })
  } else {
    walletStore.action_getTransactions({
      asset: walletStore.selectedAsset
    })
  }
})
provide('isShowAddTransactionModal', isShowAddTransactionModal)
</script>
<style lang="scss" scoped>
.email-icon {
  @apply h-8 w-8 bg-slate-100 dark:bg-slate-900 dark:text-slate-200 text-slate-600 flex flex-col justify-center items-center text-base rounded-full cursor-pointer;
}

.info-500-list {
  @apply text-xs text-slate-600;
  li {
    @apply flex space-x-2;
    span:nth-child(1) {
      @apply font-medium flex-none text-right;
    }

    span:nth-child(2) {
      @apply flex-1 text-right;
    }
  }
}
</style>
